import cardPage from './modules/cardPage';

export function bootstrap(cardsApp, dependencies, configs) {
    const app = cardsApp;
    const currentPage = cardPage.getCurrentPage();

    app.modules = {};
    app.deps = dependencies;
    app.configs = configs || {};
    app.initModules = function initModules() {
        Object.keys(app.deps)
            .filter((dep) => {
                const config = app.configs[dep];

                return !config ||
                    !config.activeOnPages ||
                    config.activeOnPages.includes(currentPage);
            })
            .forEach((dep) => {
                if (app.deps[dep] instanceof Function) {
                    app.modules[dep] = new app.deps[dep](app.configs[dep]);
                } else {
                    throw new Error(`${dep} component not found!`);
                }
            });
    };

    return app;
}



// WEBPACK FOOTER //
// ./lib/js/bootstrap.js